import Mime from 'mime/lite';
import { ExportValue } from '../ExportDimension';
import { ExportFormat, ExportOutput } from '../ExportFormat';

export class MarkdownExportFormat implements ExportFormat {

    public readonly id = 'markdown';
    public readonly label = 'Markdown';
    public readonly desc = 'For files inside Github or Gitlab, Wiki\'s that use markdown formatting or just plain text files.';

    public apply(data: ExportValue[][]): ExportOutput[] {

        const encoded = this.encode(data);

        return [
            ExportOutput(Mime.getType('md'), encoded),
            ExportOutput(Mime.getType('text'), encoded)
        ];
    }

    private encode(data: ExportValue[][]) {

        if (!data.length) return '';

        const table = data.map(row => row.map(cell => cell.value.replace(/\n/g, ' ')));
        const dims = new Array(table[0].length).fill(0);
        const pad = 2;

        for (const row of table) {
            for (let ci = 0; ci < row.length; ci++) {
                dims[ci] = Math.max(dims[ci], row[ci].length + pad);
            }
        }

        const divide = table[0].map((_v, i) => ''.padEnd(dims[i], '-'));
        const [head, ...body] = table;

        const lines = [head, divide, ...body].map(row =>
            ['| ', row.map((v, i) => v.padEnd(dims[i], ' ')).join(' | '), ' |'].join('')
        );

        return lines.join('\n');
    }

}
